import { Component } from '@angular/core';
import { ComponentRef } from '@angular/core';
import { ElementRef } from '@angular/core';
import { HostListener } from '@angular/core';
import { ViewChild } from '@angular/core';

import { BasePortalHost } from 'app/ui/core/portal';
import { ComponentPortal } from 'app/ui/core/portal';
import { UIPortalHostDirective } from 'app/ui/core/portal-directives';
import { TemplatePortal } from 'app/ui/core/portal';

@Component({
  selector: 'ui-lens',
  template: '<ng-template cdkPortalHost></ng-template>',
  styleUrls: ['lens.component.scss']
})
export class UILensComponent extends BasePortalHost {

  beaconName: string;

  @ViewChild(UIPortalHostDirective)
  private _portalHost: UIPortalHostDirective;

  constructor(private _elementRef: ElementRef) {
    super();
  }

  attachComponentPortal<T>(portal: ComponentPortal<T>): ComponentRef<T> {
    setTimeout(() => this._onUpdate());
    return this._portalHost.attachComponentPortal(portal);
  }

  attachTemplatePortal(portal: TemplatePortal): void {
    setTimeout(() => this._onUpdate());
    this._portalHost.attachTemplatePortal(portal);
  }

  private _onUpdate(): void {
    const beacon = document.querySelector(`ui-lens-beacon[name="${this.beaconName}"]`);

    if (beacon) {
      const beaconBoundingBox = beacon.getBoundingClientRect();
      const nativeElement = this._elementRef.nativeElement;
      //nativeElement.style.left = beaconBoundingBox.left + 'px';
      //nativeElement.style.top = beaconBoundingBox.top + 'px';
      nativeElement.style.visibility = 'visible';
    } else {
      setTimeout(() => this._onUpdate(), 17);
    }
  }

  @HostListener('window:resize')
  private _onResize(): void {
    this._onUpdate();
  }

}
